module.exports = __webpack_public_path__ + "img/tutorial.631d718d.png";